// Deterministic seeded RNG (mulberry32). All sim randomness goes through here so saves replay identically.
// The generator state lives in state.rng so it is persisted with the save.

export function nextFloat(state) {
  let t = (state.rng = (state.rng + 0x6d2b79f5) >>> 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export const chance = (state, p) => nextFloat(state) < p;
export const range = (state, lo, hi) => lo + (hi - lo) * nextFloat(state);
export const int = (state, lo, hi) => Math.floor(range(state, lo, hi + 1));
export const pick = (state, arr) => arr[Math.floor(nextFloat(state) * arr.length)];

// Standard normal via Box-Muller.
export function normal(state, mean = 0, sd = 1) {
  const u = Math.max(nextFloat(state), 1e-12);
  const v = nextFloat(state);
  return mean + sd * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}

// Stable 32-bit hash of (seed, key) — seeds a derived generator so independent streams (per-field
// generation, M2_SPEC §0.2) never perturb the main state.rng sequence.
export function hash32(seed, key = '') {
  let h = (2166136261 ^ (seed >>> 0)) >>> 0;
  const s = String(key);
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
  h ^= h >>> 13; h = Math.imul(h, 0x5bd1e995) >>> 0; h ^= h >>> 15;
  return h >>> 0;
}

// A throwaway rng holder usable with every helper above: range(subRng(seed, 'x'), 0, 1).
export const subRng = (seed, key) => ({ rng: hash32(seed, key) });
